import { cronHttp } from "api/cronHttp";
import { http } from "api/http";

const getGstatAtomClient = ({ queryKey }: any) => {
  return http.get(`/gstat-config/atom-client/${queryKey[1]}`);
};

const disableGstatClients = (data: any) => {
  return http.put("/gstat-config/disableGstatClients", data);
};

const disableGstatClient = (id: number) => {
  return http.put(`/gstat-config/disableGstat/${id}`);
};

const getDisabledGstatClients = ({ queryKey }: any) => {
  return http.get("/gstat-config/disabledGstatClients", { params: { ...queryKey[1] } });
};

const exportDisabledGstatClients = (data: any) => {
  return cronHttp.post("/gstat-config/export-disabledGstatClients", data);
};

const enableGstatClient = (id: number) => {
  return http.put(`/gstat-config/enableGstat/${id}`);
};

const enableBulkGstatClients = (data: any) => {
  return http.post(`/gstat-config/enableGstat/bulk-enable`, data);
};

const getGstatBulkSyncStatus = () => {
  return http.get("/gstat-config/bulkSyncStatus");
};

const updateGstatEnableStatus = () => {
  return http.put(`/gstat-config/enableStatus`);
};

const updateGstatDisableStatus = () => {
  return http.put(`/gstat-config/disableStatus`);
};

const gstatScheduling = (data: any) => {
  return http.post(`/gstat-config/scheduling`, data);
};

export {
  getGstatAtomClient,
  disableGstatClients,
  disableGstatClient,
  getDisabledGstatClients,
  exportDisabledGstatClients,
  enableGstatClient,
  enableBulkGstatClients,
  getGstatBulkSyncStatus,
  updateGstatEnableStatus,
  updateGstatDisableStatus,
  gstatScheduling,
};
